import React, { useState } from 'react';
import renderSubscriptionTab from './SubscriptionTab';
import SubscriptionTab from './SubscriptionTab';
import { PaymentsTab, samplePayments } from './PaymentsTab';
import SubscriptionCalendarDemo from './SubscriptionTabV2';
import { useCookies } from 'react-cookie';
import { UserProfileDto } from '../../Dtos/ClientDashboard/UserProfileDto';
import { DEFAULT_HEADERS, to_API_URL } from '../../Services/RestService';
export const formatDate = (timestamp: number) => {
    if (!timestamp) return 'N/A';

    return new Date(timestamp).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

// Format price from cents to dollars/euros
export const formatPrice = (priceInCents: number) => {
    if (!priceInCents) return 'N/A';

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(priceInCents / 100);
};
const UserDashboard = () => {
    const [cookies] = useCookies();
    const [email, setEmail] = useState('');
    const [userData, setUserData] = useState<UserProfileDto | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [activeTab, setActiveTab] = useState('Profile');
    // For demonstration purposes, let's show sample responses
    const handleSearch = (e: any) => {
        e.preventDefault();

        if (!email) {
            setError('Please enter an email address');
            return;
        }

        setLoading(true);

        // Simulate API call with timeout
        setTimeout(() => {
            if (email === 'demo@example.com') {
                setUserData({
                    id: 12345,
                    firstName: 'John',
                    lastName: 'Doe',
                    externalUUID: 'ext-uuid-123456',
                    email: 'demo@example.com',
                    phone: '+1 555-123-4567',
                    dob: '1985-06-15T00:00:00Z',
                    workspace: 'Personal Health',
                    isEmailConfirmed: true,
                    profileColor: 'blue',
                    country: 'United States',
                    hasProfileImg: false,
                    clientSubscription: {
                        expiresAt: Date.now() + 30 * 24 * 60 * 60 * 1000, // 30 days from now
                        nextBillingAt: Date.now() + 7 * 24 * 60 * 60 * 1000, // 7 days from now
                        enrolledAt: Date.now() - 60 * 24 * 60 * 60 * 1000, // 60 days ago
                        priceInCents: 2499,
                        subscriptionTitle: 'Premium Health Plan',
                        subscriptionDescription: 'Full access to all health tracking features',
                        subscriptionStorageInMB: 5000,
                        subscriptionStorageLeftInMB: 3750,
                        entitlements: {
                            downloadDocs: true,
                            uploadDocs: true,
                            addHealthData: true,
                            addDailySymptoms: true,
                            addVaccine: true,
                            addThirdPartyCloud: false,
                            healthDataCloudSync: true,
                            patientLimits: 5
                        }
                    },
                    patients: [
                        {
                            id: 1001,
                            firstName: 'Jane',
                            lastName: 'Doe',
                            email: 'jane@example.com'
                        },
                        {
                            id: 1002,
                            firstName: 'Michael',
                            lastName: 'Doe',
                            email: 'michael@example.com'
                        }
                    ]
                });
                setError(null);
            } else if (email === 'example@example.com') {
                setUserData({
                    id: 54321,
                    firstName: 'Alex',
                    lastName: 'Smith',
                    externalUUID: 'ext-uuid-654321',
                    email: 'example@example.com',
                    phone: '+1 555-987-6543',
                    dob: '1990-03-25T00:00:00Z',
                    workspace: 'Family Health',
                    isEmailConfirmed: false,
                    profileColor: 'green',
                    country: 'Canada',
                    hasProfileImg: true,
                    clientSubscription: {
                        expiresAt: Date.now() + 90 * 24 * 60 * 60 * 1000, // 90 days from now
                        nextBillingAt: Date.now() + 30 * 24 * 60 * 60 * 1000, // 30 days from now
                        enrolledAt: Date.now() - 180 * 24 * 60 * 60 * 1000, // 180 days ago
                        priceInCents: 4999,
                        subscriptionTitle: 'Family Health Plan',
                        subscriptionDescription: 'Complete health tracking for the whole family',
                        subscriptionStorageInMB: 10000,
                        subscriptionStorageLeftInMB: 2500,
                        entitlements: {
                            downloadDocs: true,
                            uploadDocs: true,
                            addHealthData: true,
                            addDailySymptoms: true,
                            addVaccine: true,
                            addThirdPartyCloud: true,
                            healthDataCloudSync: true,
                            patientLimits: 10
                        }
                    },
                    patients: [
                        {
                            id: 2001,
                            firstName: 'Emma',
                            lastName: 'Smith',
                            email: 'emma@example.com'
                        },
                        {
                            id: 2002,
                            firstName: 'Noah',
                            lastName: 'Smith',
                            email: 'noah@example.com'
                        },
                        {
                            id: 2003,
                            firstName: 'Olivia',
                            lastName: 'Smith',
                            email: 'olivia@example.com'
                        },
                        {
                            id: 2004,
                            firstName: 'Liam',
                            lastName: 'Smith',
                            email: 'liam@example.com'
                        }
                    ]
                });
                setError(null);
            } else {
                fetch(to_API_URL("api/v1/dashboard/users/search?email=" + email), {
                    method: "GET",
                    headers: {
                        ...DEFAULT_HEADERS,
                        "Authorization": "Bearer " + cookies.accessToken,
                    }
                })
                    .then(async result => {
                        if (result.ok) {
                            const data: UserProfileDto = await result.json();
                            console.log("data", data)
                            setUserData(data);
                        } else {
                            setUserData(null);
                        }
                    }).catch(err => {
                        console.log("error", err);
                        setError('User not found. Try "demo@example.com" or "example@example.com" for a demo.');
                        setUserData(null);
                    })
                    .finally(() => {
                        setLoading(false);

                    })
                //Fetcg

            }
        }, 100);
    };

    // Format date to readable string





    const renderProfileTab = () => {
        if (!userData) return (<div>No info</div>);
        return (<>
            {/* Basic Info Header */}
            <div className="p-6 border-b border-gray-200 flex items-center">
                <div className="w-16 h-16 rounded-full flex items-center justify-center text-white text-2xl font-bold bg-blue-500">
                    {userData.firstName ? userData.firstName.charAt(0) : userData.email.charAt(0).toUpperCase()}
                </div>
                <div className="ml-4">
                    <h2 className="text-xl font-semibold text-gray-800">
                        {userData.firstName} {userData.lastName || ''}
                    </h2>
                    <div className="flex items-center mt-1">
                        <p className="text-gray-600 mr-3">{userData.email}</p>
                        {userData.emailConfirmed ? (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                Verified
                            </span>
                        ) : (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                                Unverified
                            </span>
                        )}
                    </div>
                </div>
            </div>

            {/* User Details Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
                <div className="space-y-4">
                    <h3 className="text-lg font-medium text-gray-800">User Information</h3>

                    <div>
                        <p className="text-sm text-gray-500">User ID</p>
                        <p className="font-medium">{userData.id}</p>
                    </div>

                    <div>
                        <p className="text-sm text-gray-500">External UUID</p>
                        <p className="font-medium">{userData.externalUUID || 'N/A'}</p>
                    </div>

                    <div>
                        <p className="text-sm text-gray-500">Phone</p>
                        <p className="font-medium">{userData.phone || 'N/A'}</p>
                    </div>

                    <div>
                        <p className="text-sm text-gray-500">Date of Birth</p>
                        <p className="font-medium">{userData.dob ? formatDate(userData.dob) : 'N/A'}</p>
                    </div>

                    <div>
                        <p className="text-sm text-gray-500">Country</p>
                        <p className="font-medium">{userData.country || 'N/A'}</p>
                    </div>

                    <div>
                        <p className="text-sm text-gray-500">Workspace</p>
                        <p className="font-medium">{userData.workspace || 'N/A'}</p>
                    </div>
                </div>

                {userData.clientSubscription && (
                    <div className="space-y-4">
                        <h3 className="text-lg font-medium text-gray-800">Subscription</h3>

                        <div>
                            <p className="text-sm text-gray-500">Plan</p>
                            <p className="font-medium">{userData.clientSubscription.subscriptionTitle || 'N/A'}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500">Description</p>
                            <p className="font-medium">{userData.clientSubscription.subscriptionDescription || 'N/A'}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500">Price</p>
                            <p className="font-medium">{formatPrice(userData.clientSubscription.priceInCents)}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500">Enrolled</p>
                            <p className="font-medium">{formatDate(userData.clientSubscription.enrolledAt)}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500">Expires</p>
                            <p className="font-medium">{formatDate(userData.clientSubscription.expiresAt)}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500">Next Billing</p>
                            <p className="font-medium">{formatDate(userData.clientSubscription.nextBillingAt)}</p>
                        </div>
                    </div>
                )}

                {userData.clientSubscription && userData.clientSubscription.entitlements && (
                    <div className="space-y-4">
                        <h3 className="text-lg font-medium text-gray-800">Entitlements</h3>

                        <div className="grid grid-cols-1 gap-2">
                            {Object.entries(userData.clientSubscription.entitlements).map(([key, value]) => {
                                // Handle the special case for patientLimits
                                if (key === 'patientLimits') {
                                    return (
                                        <div key={key} className="flex justify-between">
                                            <span className="text-sm text-gray-500">Patient Limits</span>
                                            <span className="font-medium">{value}</span>
                                        </div>
                                    );
                                }

                                // For boolean values, show as enabled/disabled
                                return (
                                    <div key={key} className="flex justify-between">
                                        <span className="text-sm text-gray-500">
                                            {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                        </span>
                                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${value ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                            {value ? 'Enabled' : 'Disabled'}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Storage Information */}
                        {userData.clientSubscription.subscriptionStorageInMB && (
                            <div className="mt-4">
                                <div className="flex justify-between mb-2">
                                    <span className="text-sm text-gray-500">Storage</span>
                                    <span className="text-sm font-medium">
                                        {userData.clientSubscription.subscriptionStorageLeftInMB} MB / {userData.clientSubscription.subscriptionStorageInMB} MB
                                    </span>
                                </div>
                                <div className="w-full bg-gray-200 rounded-full h-2.5">
                                    <div
                                        className="bg-blue-600 h-2.5 rounded-full"
                                        style={{
                                            width: `${Math.min(
                                                100,
                                                (userData.clientSubscription.subscriptionStorageLeftInMB / userData.clientSubscription.subscriptionStorageInMB) * 100
                                            )}%`
                                        }}
                                    ></div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Patients Section */}
            {userData.patients && userData.patients.length > 0 && (
                <div className="p-6 border-t border-gray-200">
                    <h3 className="text-lg font-medium text-gray-800 mb-4">Patients</h3>
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {userData.patients.map((patient, index) => (
                                    <tr key={patient.backendId || index}>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{patient.backendId || 'N/A'}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                            {patient.name} {patient.lastName || ''}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{'N/A'}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                                Active
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
        );
    }

    const renderManageTab = () => (
        <div className="p-6">
            <h3 className="text-lg font-medium text-gray-800 mb-6">Manage Account</h3>
            Comming Soon
            {/*  <div className="space-y-6">
                <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="text-md font-medium text-gray-700 mb-2">Account Status</h4>
                    <div className="flex items-center">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 mr-2">
                            Active
                        </span>
                        <span className="text-sm text-gray-600">Since {formatDate(userData.createdAt)}</span>
                    </div>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="text-md font-medium text-gray-700 mb-2">Account Actions</h4>
                    <div className="space-y-4">
                        <button className="inline-flex items-center px-4 py-2 border border-red-600 text-red-600 rounded-md hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                            Block Account
                        </button>
                        <div>
                            <p className="text-sm text-gray-500 mb-2">Last login: {formatDate(userData.lastLogin)}</p>
                            <p className="text-sm text-gray-500">IP: {userData.lastIp || 'N/A'}</p>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    );

    const renderAppInfoTab = () => (
        <div className="p-6">
            <h3 className="text-lg font-medium text-gray-800 mb-6">Application Information</h3>

            <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                <div className="px-4 py-5 sm:px-6 bg-gray-50">
                    <h4 className="text-md font-medium text-gray-700">System Details</h4>
                </div>
                <div className="border-t border-gray-200">
                    <dl>
                        <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">App Version</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                2.5.3
                            </dd>
                        </div>
                        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Last Updated</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {formatDate(new Date())}
                            </dd>
                        </div>
                        <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Platform</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                Web
                            </dd>
                        </div>
                        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt className="text-sm font-medium text-gray-500">Environment</dt>
                            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                Production
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    );

    const renderCommunicationTab = () => (
        <div className="p-6">
            <h3 className="text-lg font-medium text-gray-800 mb-6">Communication</h3>

            <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                <div className="px-4 py-5 sm:px-6 bg-gray-50">
                    <h4 className="text-md font-medium text-gray-700">Send Email</h4>
                    <p className="mt-1 max-w-2xl text-sm text-gray-500">
                        Send a message to {userData.email}
                    </p>
                </div>
                <div className="border-t border-gray-200 p-4">
                    <div className="space-y-4">
                        <div>
                            <label htmlFor="subject" className="block text-sm font-medium text-gray-700">
                                Subject
                            </label>
                            <input
                                type="text"
                                name="subject"
                                id="subject"
                                className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                placeholder="Email subject"
                            />
                        </div>
                        <div>
                            <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                                Message
                            </label>
                            <textarea
                                id="message"
                                name="message"
                                rows={6}
                                className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                placeholder="Type your message here..."
                            />
                        </div>
                        <div>
                            <button
                                type="button"
                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            >
                                Send Email
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );



    const renderTabContent = () => {
        switch (activeTab) {
            case 'Profile':
                return renderProfileTab();
            case 'Manage':
                return renderManageTab();
            case 'Subscription':
                if (userData) {
                    return <SubscriptionCalendarDemo user={userData} />
                }
                return null;
            case 'App Info':
                return renderAppInfoTab();
            case 'Communication':
                return renderCommunicationTab();
            case 'Payments':
                return <PaymentsTab payments={samplePayments} />
            default:
                return renderProfileTab();
        }
    };



    return (
        <div className="min-h-screen bg-gray-50 p-6">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <header className="mb-8">
                    <h1 className="text-3xl font-bold text-gray-800">User Dashboard</h1>
                    <p className="text-gray-600 mt-2">Search and view user information</p>
                </header>

                {/* Search Bar */}
                <div className="bg-white rounded-lg shadow p-6 mb-8" >
                    <form onSubmit={handleSearch} className="flex flex-col md:flex-row gap-4">
                        <div className="flex-grow"  >
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                User Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter user email (try demo@example.com or example@example.com)"
                                className="w-full px-4 py-2 border border-gray-300 rounded-ms focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div className="self-end" style={{ display: "flex", alignItems: "flex-end", marginLeft: 14 }} >
                            <button
                                type="submit"
                                className="px-6 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                disabled={loading}
                            >
                                {loading ? 'Searching...' : 'Search'}
                            </button>
                        </div>
                    </form>

                    {error && (
                        <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md">
                            {error}
                        </div>
                    )}
                </div>

                {/* User Information */}
                {userData && (
                    <div className="bg-white rounded-lg shadow overflow-hidden">
                        {/* Tabs */}
                        <div className="border-b border-gray-200">
                            <nav className="flex overflow-x-auto">
                                {['Profile', 'Manage', 'Subscription', 'App Info', 'Communication', 'Payments'].map((tab) => (
                                    <button
                                        key={tab}
                                        onClick={() => setActiveTab(tab)}
                                        className={`py-4 px-6 text-center border-b-2 font-medium text-sm whitespace-nowrap ${activeTab === tab
                                            ? 'border-blue-500 text-blue-600'
                                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                            }`}
                                    >
                                        {tab}
                                    </button>
                                ))}
                            </nav>
                        </div>

                        {/* Tab Content */}
                        {renderTabContent()}
                    </div>
                )}
            </div>
        </div>
    );

}

export default UserDashboard;